/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* -------------------------------------------------------------------------- *\
   SWM Multiple Product Variant Form
\* -------------------------------------------------------------------------- */

function swmMultipleVariantForm() {
    const forms = document.querySelectorAll('.js-swm-multiple-variant-form');
    const qtys = document.querySelectorAll('.js-swm-multiple-variant-form input[type="number"]');

    qtys.forEach(qty => {
        qty.addEventListener('input', (event) => {
            if (qty.validity.rangeOverflow) {
                qty.setCustomValidity('This quantity exceeds the available inventory');
            } else {
                qty.setCustomValidity('');
            }
        });
    });

    forms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const formRows = this.querySelectorAll('[data-swm-multivariant-id]');
            let itemCount = 0;
            let formData = {
                'items': []
            };

            formRows.forEach(row => {
                const id = row.dataset.swmMultivariantId;
                const input = row.querySelector('input[type="number"]');

                let qty;
                if (input) {
                    qty = parseInt(input.value);

                    if (qty > 0) {
                        qty = Math.round(qty);
                    } else {
                        qty = 0;
                    }
                } else {
                    qty = 0;
                }

                itemCount += qty;

                if (qty > 0) {
                    formData.items.push({
                        'id': id,
                        'quantity': qty
                    });
                }
            });

            if (itemCount > 0) {

                //Trigger loading bar similar to <buy-button>
                document.dispatchEvent(new CustomEvent("theme:loading:start"));

                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    if (response.ok) {
                        form.reset();

                        //Needs 'detail.productAdded' to trigger cart open
                        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
                            bubbles: true,
                            detail: {
                                productAdded: true,
                                quantity: itemCount
                            }
                        }));
                    
                        document.dispatchEvent(new CustomEvent("modal:close"));
                    } else {
                        response.json().then(content => {
                            form.reset();

                            const messageContainer = form.querySelector('tfoot > tr > td:last-child');

                            let messageElement = document.createElement("div");
                            messageElement.className = `cart__status-message cart__status-message--product`;
                            messageElement.innerHTML = `<div class="alert alert--error"><p>${content.message}</p></div>`;

                            messageContainer.appendChild(messageElement);

                            Animation.slideDown(messageElement);
                            setTimeout(function() {
                                Animation.slideUp(messageElement, () => {
                                    messageElement.remove();
                                });
                            }, 5500);

                            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
                                bubbles: true
                            }));

                           //document.dispatchEvent(new CustomEvent("theme:loading:end"));
                        });
                    }
                });
            }
        })
    });
}

swmMultipleVariantForm();